:host {
  display: block;
}

.banner-disqualified-class {
  @apply flex px-5 gap-0 mx-auto bg-clrs-kbb-airforceblue border-clrs-kbb-gold border-solid border-2 rounded justify-between text-clrs-white font-open-sans;
}